import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { galleryImages } from '../data/mock';
import { X } from 'lucide-react';
import { useScrollAnimation, useGalleryAnimation } from '../hooks/useScrollAnimation';

// Egyedi komponens minden képhez - EGYSZERŰ
const GalleryImage = ({ image, index, onClick, t }) => {
  const [ref, isVisible] = useGalleryAnimation();
  
  // Bal oldali képek balról, jobb oldali képek jobbról
  const isLeftSide = index % 2 === 0;
  const animationClass = isLeftSide ? 'slide-in-left' : 'slide-in-right';

  return (
    <div
      ref={ref}
      onClick={() => onClick(image)}
      className={`relative aspect-square overflow-hidden rounded-sm cursor-pointer group ${animationClass} ${isVisible ? 'visible' : ''}`}
    >
      <img
        src={image.url}
        alt={image.alt}
        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        loading="lazy"
        decoding="async"
      />
      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/50 transition-colors duration-300 flex items-center justify-center">
        <span className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 font-montserrat text-sm uppercase tracking-wider">
          {t('gallery.view')}
        </span>
      </div>
    </div>
  );
};

const Gallery = () => {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);
  const [titleRef, titleVisible] = useScrollAnimation(0.1);

  return (
    <section id="gallery" className="py-32 bg-neutral-950">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div 
          ref={titleRef}
          className={`mb-20 fade-in ${titleVisible ? 'visible' : ''}`}
        >
          <p className="text-white text-xs uppercase tracking-[0.3em] mb-4 font-montserrat font-medium">Portfóliónk</p>
          <h2 className="text-5xl md:text-6xl font-oswald font-bold text-white mb-6 uppercase tracking-tighter">
            {t('gallery.title')}
          </h2>
          <p className="text-gray-400 text-base max-w-3xl font-montserrat font-light">
            {t('gallery.subtitle')}
          </p>
        </div>

        {/* 2 oszlopos grid - dominó animáció */}
        <div className="grid grid-cols-2 md:grid-cols-2 gap-4 md:gap-6">
          {galleryImages.map((image, index) => (
            <GalleryImage
              key={image.id}
              image={image}
              index={index}
              onClick={setSelectedImage}
              t={t}
            />
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          onClick={() => setSelectedImage(null)}
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4 animate-in fade-in duration-300"
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-6 right-6 text-white hover:bg-white/10 rounded-full p-2 transition-colors"
          >
            <X className="w-8 h-8" />
          </button>
          <img
            src={selectedImage.url}
            alt={selectedImage.alt}
            className="max-w-full max-h-[90vh] object-contain rounded-sm"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};

export default Gallery;
